import { PasswordComplexity } from "../components/passwordComplexity";
import { DefaultOauthLink, LoginLink } from "../constants/general";
import { DomUtils } from "../utils/domUtils";
import { LocationUtils } from "../utils/locationUtils";
import { BaseController } from "./base";

export const NewPasswordConstants = {
	newPasswordButton: "newPasswordButton",
	newPasswordForm: "newPasswordForm",
	newPassword: "newPassword",
	confirmPassword: "confirmPassword",
	passwordMatchWarning: "passwordMatchWarning",
	passwordComplexityPatternWarning: "passwordComplexityPatternWarning",
	loginLink: "loginLink"
};

export class NewPasswordController extends BaseController {
	constructor() {
		super();

		this._message = null;
		this._passwordComplexity = null;
		this._loginLink = null;
		this._signIn = null;
	}

	Init() {
		this._GetContextData();

		this._ShowMessage(this._message);

		this._SetupForm();

		this._BindEvents();
		this._FocusInput();
	}

	_GetContextData() {
		this._message = window.message;

		this._signIn = LocationUtils.GetQueryParam("signin");

		if (!!this._signIn) {
			this._loginLink = `${LoginLink}${this._signIn}`;
		}
		else {
			this._loginLink = DefaultOauthLink;
		}

		if (!!window.domainProperties) {
			this._pattern = window.domainProperties.PasswordComplexityPattern;
		}
	}

	_SetupForm() {
		this._SetupFromAction();
		this._SetupLoginLink();

		this._SetupPasswordComplexity();
		this._TogglePasswordMatchWarning(true);
	}

	_SetupFromAction() {
		const newPasswordForm = DomUtils.GetElement(NewPasswordConstants.newPasswordForm);
		newPasswordForm.action = `ResetComplete?signIn=${this._signIn}`;
	}

	_SetupLoginLink() {
		const loginLink = DomUtils.GetElement(NewPasswordConstants.loginLink);
		loginLink.href = this._loginLink;
	}

	_TogglePasswordMatchWarning(isValid) {
		DomUtils.ShowHide(!isValid, NewPasswordConstants.passwordMatchWarning);

		const confirmPasswordElement = DomUtils.GetElement(NewPasswordConstants.confirmPassword);
		confirmPasswordElement.classList.toggle("invalid", !isValid);
	}

	_TogglePasswordComplexityPatternWarning(visible) {
		DomUtils.ShowHide(visible, NewPasswordConstants.passwordComplexityPatternWarning);
	}

	_BindEvents() {
		this._BindNewPasswordButton();
		this._BindPasswordMatchWarning();
	}

	_FocusInput() {
		this._FocusElement(NewPasswordConstants.newPassword);
	}

	_BindNewPasswordButton() {
		const newPasswordButton = DomUtils.GetElement(NewPasswordConstants.newPasswordButton);
		newPasswordButton.addEventListener("click", () => this._OnNewPasswordButtonClick());
	}

	_BindPasswordMatchWarning() {
		const newPasswordInput = DomUtils.GetElement(NewPasswordConstants.newPassword);
		const confirmPasswordInput = DomUtils.GetElement(NewPasswordConstants.confirmPassword);

		newPasswordInput.addEventListener("keyup", () => this._ValidatePasswordMatch());
		confirmPasswordInput.addEventListener("keyup", () => this._ValidatePasswordMatch());
	}

	_ValidatePasswordMatch() {
		const newPasswordInput = DomUtils.GetElement(NewPasswordConstants.newPassword);
		const confirmPasswordInput = DomUtils.GetElement(NewPasswordConstants.confirmPassword);

		const newPassword = newPasswordInput.value;
		const confirmPassword = confirmPasswordInput.value;

		const success = !!newPassword && !!confirmPassword && newPassword === confirmPassword;
		this._TogglePasswordMatchWarning(success);

		return success;
	}

	_SetupPasswordComplexity() {
		PasswordComplexity.Init(NewPasswordConstants.newPassword, this._pattern);
	}

	_ValidatePasswordComplexity() {
		const newPasswordInput = DomUtils.GetElement(NewPasswordConstants.newPassword);
		const result = newPasswordInput.validate();

		return result;
	}

	_OnNewPasswordButtonClick() {
		if (this._Validate() === true) {
			this._SubmitForm();
		}
	}

	_Validate() {
		const passwordComplexity = this._ValidatePasswordComplexity();
		const passwordMatch = this._ValidatePasswordMatch();

		return passwordComplexity && passwordMatch;
	}

	/* istanbul ignore next */
	_SubmitForm() {
		super._SubmitForm(NewPasswordConstants.newPasswordForm);
	}
}
